// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Predefined asset marker icon categories and their associated MUI icons.
 * Used by both the asset marker selector and organization default asset marker components.
 */
import {
  Battery0BarOutlined,
  BiotechOutlined,
  CameraAltOutlined,
  ChargingStationOutlined,
  CoffeeMakerOutlined,
  ComputerOutlined,
  DirectionsBoatOutlined,
  DirectionsBusOutlined,
  DirectionsCarOutlined,
  DirectionsRailwayOutlined,
  FlightOutlined,
  MicrowaveOutlined,
  NestCamWiredStandOutlined,
  PedalBikeOutlined,
  PointOfSaleOutlined,
  PrecisionManufacturingRounded,
  PrintOutlined,
  RouterOutlined,
  SensorsOutlined,
  SpeakerOutlined,
  VideogameAssetOutlined,
} from '@/constants/hardfin-standard-icons';

export const MARKER_CATEGORIES = {
  'Vehicles/machines': {
    PedalBikeOutlined,
    DirectionsCarOutlined,
    DirectionsBusOutlined,
    DirectionsRailwayOutlined,
    DirectionsBoatOutlined,
    FlightOutlined,
    PrecisionManufacturingRounded,
  },
  'Technology/equipment': {
    ComputerOutlined,
    PrintOutlined,
    RouterOutlined,
    SpeakerOutlined,
    CameraAltOutlined,
    NestCamWiredStandOutlined,
    SensorsOutlined,
  },
  'Devices/systems': {
    Battery0BarOutlined,
    ChargingStationOutlined,
    PointOfSaleOutlined,
    MicrowaveOutlined,
    CoffeeMakerOutlined,
    BiotechOutlined,
    VideogameAssetOutlined,
  },
};
